import { RouteConfig } from 'vue-router';

import store from '@/store/store';
import { tryParseInt } from '@/utils/number';
import Club from '@/views/club/Club.vue';
import { teamsContainerRoute } from '../teamsContainer.route';
import { clubCalendarRoute } from './club/calendar.route';
import { clubDetailsRoute } from './club/details.route';
import { clubEditRoute } from './club/edit.route';
import { clubExamsRoute } from './club/exams.route';
import { clubFeesContainerRoute } from './club/feesContainer.route';
import { offersRoute } from './club/offers.route';

export const clubRoute: RouteConfig = {
  path: ':clubId',
  component: Club,
  meta: {
    authorized: true,
    breadcrumb: {
      title: 'breadcrumbs.clubs.view',
      name: 'club'
    }
  },
  redirect: { name: 'club' },
  children: [
    clubDetailsRoute,
    teamsContainerRoute,
    offersRoute,
    clubEditRoute,
    clubCalendarRoute,
    clubFeesContainerRoute,
    clubExamsRoute
  ],
  beforeEnter: (to: any, from: any, next: any) => {
    store.commit('club/setId', tryParseInt(to.params.clubId));
    store
      .dispatch('club/get')
      .then(club => {
        clubRoute.meta.breadcrumb.title = club.name;
        next();
      })
      .catch(() => store.dispatch('notifyError', { title: 'messages.club.getError' }));
  }
};
